export default (params) => ({
  trigger: {
    name: 'reviews.read_all_reviews',
    params: params,
  },
  config: {
    schema: {
      content: {
        type: 'string',
      },
    },
    event: {
      name: 'select_all',
      params: {
        sub_feature: 'below_element',
      },
    },
  },
});
